module.exports = __webpack_public_path__ + "img/cartoon3.d0494694.jpg";